import { useLocation } from '@remix-run/react';

import type { LinksFunction } from '@remix-run/node';

import clsx from 'clsx';

import {
  SharedAnchor,
  links as sharedAnchorLinks,
} from '@/components/shared/shared-anchor/shared-anchor';
import {
  SharedAriaLink,
  links as sharedAriaLinkLinks,
} from '@/components/shared/shared-aria-link/shared-aria-link';

import { AURA_URL } from '@/constants/urls';
import { getDestination } from '@/utils/getDestination';

import iconAuraLogoDark from '@/img/icon-aura-logo-dark.svg?url';

import type { SharedHeaderProps } from './shared-header.types';

import styles from './shared-header.css?url';

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: styles },
  ...sharedAnchorLinks(),
  ...sharedAriaLinkLinks(),
];

export function SharedHeader({ theme = 'light' }: SharedHeaderProps) {
  const location = useLocation();

  const logoDestination = getDestination(location.pathname);
  const headerClassnames = clsx('shared-header', {
    'shared-header--light': theme === 'light',
    'shared-header--dark': theme === 'dark',
  });

  return (
    <div className="container">
      <header className={headerClassnames}>
        <SharedAnchor href={logoDestination} title="Go to home page">
          <img
            className="shared-header__logo"
            src={iconAuraLogoDark}
            alt="Aura Logo"
          />
        </SharedAnchor>
        <SharedAriaLink
          className="shared-header__button"
          href={AURA_URL}
          intent="secondary"
          title="About Aura"
        >
          About Aura
        </SharedAriaLink>
      </header>
    </div>
  );
}
